import {Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledBasketBodyEmptyWrapper = styled(Box)<{isFlexibleBasketEnabled: boolean}>(
  ({theme, isFlexibleBasketEnabled}) => ({
    width: '100%',
    display: 'flex',
    height: '100%',
    background: isFlexibleBasketEnabled ? '#F4F4F4' : theme.palette.common.white,
    alignItems: 'center',
    justifyContent: 'center'
  })
);

export const StyledEmptyContainer = styled(Box)<{isFlexibleBasketEnabled: boolean}>(({isFlexibleBasketEnabled}) => ({
  width: '100%',
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  gap: isFlexibleBasketEnabled ? '16px' : ''
}));

export const StyledEmptyImage = styled(Box)(() => ({
  width: 200,
  height: 200
}));

export const StyledEmptyContent = styled(Box)(() => ({
  width: '100%'
}));

export const StyledTitle = styled(Typography)<TypographyProps>(({theme}) => ({
  fontWeight: 600,
  marginBottom: theme.spacing(0.5)
}));

export const StyledDescription = styled(Typography)<TypographyProps>(({theme}) => ({
  color: theme.palette.grey[400],
  marginBottom: theme.spacing(2)
}));
